import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { NavBarBtnModel } from 'common/src/models';
import { AllocationRulesTabsEnum, GeneralLedgerPlanModel, GeneralLedgerPlatformModel, TaxCodesTabsEnum } from '../models';

@Injectable({
  providedIn: 'root'
})
export class GlMainNavService {

  readonly activeRulesTab$: BehaviorSubject<AllocationRulesTabsEnum> = new BehaviorSubject<AllocationRulesTabsEnum>(AllocationRulesTabsEnum.SALES);
  readonly activeCodesTab$: BehaviorSubject<TaxCodesTabsEnum> = new BehaviorSubject<TaxCodesTabsEnum>(TaxCodesTabsEnum.SALES);
  readonly actionSubject$: Subject<string> = new Subject<string>();
  // readonly actionButtons$: BehaviorSubject<NavBarBtnModel[]> = new BehaviorSubject<NavBarBtnModel[]>([]);
  readonly isReadonly$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  readonly isLoadingContent$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  readonly contentUpdatedAt$: BehaviorSubject<Date> = new BehaviorSubject<Date>(new Date());
  readonly btnToClearLoadingStatus$: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  readonly plan$: BehaviorSubject<GeneralLedgerPlanModel> = new BehaviorSubject<GeneralLedgerPlanModel>(null);
  readonly platforms$: BehaviorSubject<GeneralLedgerPlatformModel[]> = new BehaviorSubject<GeneralLedgerPlatformModel[]>([]);
  readonly currentPlatform$: Observable<GeneralLedgerPlatformModel> = combineLatest([this.plan$, this.platforms$])
    .pipe(
      map(([plan, platforms]) => plan
        ? platforms.find((platform: GeneralLedgerPlatformModel) => platform.id === plan.basePlatformId) || null
        : null
      )
    );

  // public emitAction(action: string): void {
  //   this.actionSubject$.next(action);
  // }

  // public setActionButtons(buttons: NavBarBtnModel[]) {
  //   this.actionButtons$.next(buttons);
  // }

  public setActiveRulesTab(tab: AllocationRulesTabsEnum) {
    this.activeRulesTab$.next(tab);
  }

  public setActiveCodesTab(tab: TaxCodesTabsEnum) {
    this.activeCodesTab$.next(tab);
  }

  public setReadonly(isReadonly: boolean) {
    this.isReadonly$.next(isReadonly);
  }

  public setPlan(plan: GeneralLedgerPlanModel) {
    this.plan$.next(plan);
  }

  public setPlatforms(platforms: GeneralLedgerPlatformModel[]) {
    this.platforms$.next(platforms || []);
  }

  public emitSync() {
    this.isLoadingContent$.next(true);
  }

  public syncFinished() {
    this.isLoadingContent$.next(false);
    this.contentUpdatedAt$.next(new Date());
  }

}
